// export const DEFAULT_BROWSE_APP = '/public/browse'
export const DEFAULT_BROWSE_APP = '/'

export const OVERRIDE_STATUS_MAPPING_RULES = {
  avail: 'For Sale',
  unavail: 'Not For Sale',
  sold: 'Sold',
}

export const OVERRIDE_SORT_MAPPING_RULES = {
  default: 'Recommended',
  newest: 'Date Listed: New to Old',
  'price-low': 'Price: Low to High',
  'price-high': 'Price: High to Low',
}

export const OVERRIDE_MATERIALS_MAPPING_RULES = {
  rag: 'Fine Art Paper',
  canvas: 'Canvas',
  photo: 'Photo Paper',
  acrylic: 'Acrylic',
  metal: 'Metal',
}

export const OVERRIDE_ORIENTATION_MAPPING_RULES = {
  landscape: 'Horizontal',
  portrait: 'Vertical',
  square: 'Square',
}

export const BOOLEAN_FACETS_MAPPING_VALUE = {
  is_outdoor: 'outdoor',
}

export const OVERRIDE_IS_OUTDOOR_MAPPING_RULES = {
  is_outdoor: 'outdoor',
}
